import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { PartLog } from "../../models/Part";
import { logTypeCodes, LogTypeTag } from "./LogTypeTag";

export const useTableData = () => {
	const columnDefs: ColDef[] = [
		{
			field: "LogTypeCode",
			headerName: "Type",
			minWidth: 20,
			maxWidth: 70,
			flex: 1,
			valueGetter: (params) =>
				logTypeCodes.find(
					(code) => code.Code === (params.data as PartLog).LogTypeCode,
				)?.Name,
			cellRenderer: LogTypeTag,
			cellRendererParams: (params: ICellRendererParams) => ({
				type: logTypeCodes.find(
					(code) => code.Code === (params.data as PartLog).LogTypeCode,
				),
			}),
		},
		{
			field: "Timestamp",
			headerName: "Timestamp",
			minWidth: 20,
			flex: 1,
			valueGetter: (params) =>
				dxtToLocalServerTime(params?.data.Timestamp, "MM/dd/yy HH:mm") || "",
		},
		{
			field: "Source",
			headerName: "Source",
			minWidth: 300,
			flex: 2,
			cellStyle: {
				justifyContent: "flex-start",
			},
		},
		{
			field: "Message",
			headerName: "Description",
			minWidth: 300,
			flex: 6,
			cellStyle: {
				justifyContent: "flex-start",
			},
			wrapText: true,
			autoHeight: true,
		},
	];
	return { columnDefs };
};
